import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../../contexts/UserContext';

// Fonction pour convertir le texte brut en HTML
const convertToHTML = (text) => {
    return text
        .replace(/\n/g, '<br/>')      // Convertir les retours à la ligne en balises <br>
        .replace(/\s\s/g, '&nbsp;');  // Convertir les doubles espaces en espaces insécables
};

const Emails = () => {
    const [emails, setEmails] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null); // État pour l'email sélectionné
    const [showEditModal, setShowEditModal] = useState(false); // État pour gérer la visibilité du modal
    const { user } = useContext(UserContext);

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                const emailsCollection = collection(db, 'email');
                const emailsSnapshot = await getDocs(emailsCollection);
                let emailsList = emailsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setEmails(emailsList);
            } catch (error) {
                console.error("Error fetching emails: ", error);
            }
        };

        fetchEmails();
    }, []);

    // Fonction pour gérer l'ouverture du modal d'édition
    const handleShowEdit = (email) => {
        setSelectedEmail(email);
        setShowEditModal(true);
    };

    // Fonction pour gérer la sauvegarde des modifications
    const handleSave = async () => {
        try {
            const emailDoc = doc(db, 'email', selectedEmail.id);
            await updateDoc(emailDoc, {
                objet: selectedEmail.objet,
                texte: convertToHTML(selectedEmail.texte),  // Convertir en HTML avant de sauvegarder
                texte2: convertToHTML(selectedEmail.texte2), // Convertir en HTML avant de sauvegarder
            });
            setShowEditModal(false); // Fermer le modal après la sauvegarde
        } catch (error) {
            console.error('Error updating email: ', error);
        }
    };

    // Fonction pour gérer les changements dans le formulaire de modification
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectedEmail((prevEmail) => ({
            ...prevEmail,
            [name]: value
        }));
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Gestion des Email envoyés au client</h6>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>id</th>
                                            <th>Objet</th>
                                            <th>Contenu avant informations</th>
                                            <th>Contenu après informations</th>
                                            {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                <th>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {emails.map((email) => (
                                            <tr key={email.id}>
                                                <td>{email.id}</td>
                                                <td>{email.objet}</td>
                                                <td>{email.texte}</td>
                                                <td>{email.texte2}</td>
                                                {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                    <td>
                                                        <button className="btn btn-primary btn-sm ml-2" onClick={() => handleShowEdit(email)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'édition */}
            {showEditModal && (
                <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Modifier Email</h5>
                                <button type="button" className="close" onClick={() => setShowEditModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label>Objet</label>
                                        <input
                                            type="text"
                                            name="objet"
                                            className="form-control"
                                            value={selectedEmail.objet}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Contenu avant informations</label>
                                        <textarea
                                            name="texte"
                                            className="form-control"
                                            rows="4"
                                            value={selectedEmail.texte}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label>Contenu après informations</label>
                                        <textarea
                                            name="texte2"
                                            className="form-control"
                                            rows="4"
                                            value={selectedEmail.texte2}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                                    Fermer
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>
                                    Sauvegarder
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Emails;
